import styles from './CorreoModule.module.css';

/** Chip coloreado según el estado del envío (verde=bueno, ámbar=en curso, rojo=fallo). */
export function EstadoChip({ estado }: { estado: string }) {
  const ok = new Set(['Entregado', 'Enviado']);
  const warn = new Set(['EnCola', 'Programado']);
  const err = new Set(['Rebotado', 'Queja', 'NoEntregable']);
  const clase = ok.has(estado) ? styles.chipOk : warn.has(estado) ? styles.chipWarn : err.has(estado) ? styles.chipErr : styles.chip;
  return <span className={`${styles.chip} ${clase}`}>{estado}</span>;
}
